/* eslint-disable */
let self;
let form_name;
let form_id;
let form_type;
let form_variant;
let step_name;
let step;
let user_email;
let user_id;
let event;

export class DataLayer_form {
  constructor(datalayer_attr) { // Receive part of the attributes to create the datalayer
    self = this;
    // Store the received data in local variables
    form_name = datalayer_attr.form_name;
    form_id = datalayer_attr.form_id;
    form_type = datalayer_attr.form_type;
    form_variant = datalayer_attr.form_variant;
    step_name = datalayer_attr.step_name;
    step = datalayer_attr.step;
    user_email = datalayer_attr.user_email;
    event = datalayer_attr.event;

    const datalayer = {
      event: event,
      form_name: form_name,
      form_id: form_id,
      form_type: form_type,
      form_variant: form_variant,
      step_name: step_name,
      step: step,
      user: {}
    };

    self.getDatalayerExtraAttr(datalayer);

    // Create and push the datalayer
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(datalayer);

  }

  // Define the extra attributes
  getDatalayerExtraAttr(datalayer) {

    if (step === '2' && user_email) {
      datalayer.user.user_hashed_email = user_email;
    }

    // Set user id to localStorage key if set, else get it via ajax
    user_id = window.localStorage.getItem('user_id');
    if (!user_id) {
      // set user_email if user_email is set, else pick it up from the local storage
      user_email = user_email ?? window.localStorage.getItem('user_email_key');
      if (user_email) {
        $.ajax({
          url: ajax_link,
          method: 'post',
          async: false, // fix for put values in variables
          data: {
            action: 'lyceo_hash',
            nonce: ajax_nonce,
            string: user_email,
          },
        }).done(function (data) {
          user_id = data;
          window.localStorage.setItem('user_id', user_id);
        });
      }
    }
    // Set user_id in the datalayer
    if (user_id) {
      datalayer.user.user_id = user_id;
    }
  }
}
